import React from "react";

function RootCanalTreatment() {
  return <div>RootCanalTreatment</div>;
}

export default RootCanalTreatment;
